import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React from 'react';
import {
	RETURN_PAYMENT_MODAL__BODY_TEXT_TITLE,
	RETURN_PAYMENT_MODAL__CANCEL,
	RETURN_PAYMENT_MODAL__SUBMIT,
	RETURN_PAYMENT_MODAL__TITLE,
} from '../data/constants';

interface ReturnPaymentModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const ReturnPaymentModal = (props: ReturnPaymentModalProps) => {
	const { open, onClose, onConfirm } = props;
	return (
		<Dialog open={open} onClose={onClose}>
			<DialogTitle>{RETURN_PAYMENT_MODAL__TITLE}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					{RETURN_PAYMENT_MODAL__BODY_TEXT_TITLE}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} color='neutralButton'>
					{RETURN_PAYMENT_MODAL__CANCEL}
				</Button>
				<Button onClick={onConfirm} variant='contained' color='primary'>
					{RETURN_PAYMENT_MODAL__SUBMIT}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ReturnPaymentModal;
